import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Table, Button, Divider, message, Input, Select } from 'antd';
import config from '../../Config/key';
// テーブル強化 PJ Ph.3: 列リサイズ + ソート + 省略
import {
  PageContainer,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
  dateSorter,
} from '../../common';
// import { surveyCode } from '../../Config/surveyCode';

const VideoDeliveryMgrPage = (props) => {
  // console.log({ props });
  const { user } = props;
  const [VDInfo, setVDInfo] = useState([]);
  // 検索条件（タイトル・納品説明 = 部分一致、視聴期間 = 内/外の絞り込み）
  const [search, setSearch] = useState({
    title: '',
    desc: '',
    period: 'all', // all | in | out
  });

  //yyyy/mm/dd
  const ymd = (tdate) => {
    let date = new Date(tdate);
    // console.log({ tdate });
    return (
      ('0' + date.getFullYear()).slice(-2) +
      '年' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '月' +
      ('0' + date.getDate()).slice(-2) +
      '日'
      // date.getMilliseconds()
    );
  };

  const readDB = async () => {
    try {
      if (!user.userData) return null;
      // console.log(user.userData.isAuth);
      if (user.userData.isAuth) {
        const res = await Axios.get('/api/videoDelivery/');
        // console.log(res.data.groups);
        if (res.data.success) {
          let vdArr = res.data.videoDelivery;
          vdArr.map((element) => {
            element.delivery_s = ymd(element.delivery_start);
            element.delivery_e = ymd(element.delivery_end);
            return element;
          });
          // console.log(vdArr);
          setVDInfo(vdArr);
        } else {
          throw new Error('動画データ取得に失敗しました。');
        }
      } else {
        throw new Error('ログイン前です。');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ mySurvey });
  }, [user]);

  //クリップボードにコピー関数
  const copyToClipboard = async (vdInfo, e) => {
    // console.log(vdInfo);
    await global.navigator.clipboard.writeText(
      `${config.BACKEND_SERVER}/videolist/videoview/${vdInfo.token}`
    );
    message.success({
      content: 'OneTimeURLがクリップボードにコピーできました。',
      key: 'ccopy',
      duration: 3,
    });
  };
  //納品ページを開く関数（バイパストークン付き）
  const openVideoPage = async (vdInfo, e) => {
    try {
      // バイパストークンを生成
      const res = await Axios.post('/api/videoDelivery/generate-bypass-token', {
        token: vdInfo.token,
      });

      if (res.data.success) {
        const bypassToken = res.data.bypassToken;
        // バイパストークンをクエリパラメータとして追加
        window.open(
          `${config.BACKEND_SERVER}/videolist/videoview/${vdInfo.token}?bypass=${bypassToken}`,
          '_blank'
        );
      } else {
        message.error({
          content: '納品ページを開けませんでした。',
          key: 'openError',
          duration: 3,
        });
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: '納品ページを開けませんでした。',
        key: 'openError',
        duration: 3,
      });
    }
  };

  const editVDHandler = async (vdInfo, e) => {
    e.preventDefault();
    try {
      vdInfo.fg = 'edit';
      props.history.push({
        pathname: '/videodelivery',
        state: vdInfo,
      });
    } catch (error) {
      console.log(error);
    }
  };
  const newVDHandler = async (e) => {
    e.preventDefault();
    try {
      props.history.push({
        pathname: '/videodelivery',
        state: { fg: 'new' },
      });
    } catch (error) {
      console.log(error);
    }
  };

  // 検索条件をクリア
  const clearSearch = () => {
    setSearch({ title: '', desc: '', period: 'all' });
  };

  // 視聴期間内・外の判定（現在日時が delivery_start〜delivery_end の範囲内か）
  const isInPeriod = (vd) => {
    const now = Date.now();
    const start = new Date(vd.delivery_start).getTime();
    const end = new Date(vd.delivery_end).getTime();
    return now >= start && now <= end;
  };

  // 絞り込み後の一覧（タイトル・納品説明は部分一致、視聴期間は内/外）
  const filteredVDInfo = VDInfo.filter((vd) => {
    const byTitle =
      !search.title ||
      (vd.main_title || '').toLowerCase().includes(search.title.toLowerCase());
    const byDesc =
      !search.desc ||
      (vd.delivery_description || '')
        .toLowerCase()
        .includes(search.desc.toLowerCase());
    let byPeriod = true;
    if (search.period === 'in') byPeriod = isInPeriod(vd);
    else if (search.period === 'out') byPeriod = !isInPeriod(vd);
    return byTitle && byDesc && byPeriod;
  });

  // テーブル強化 PJ Ph.3: <Column> 子要素 → columns 配列。テキスト列はソート + 省略、
  // 日付列は実日付ソート、操作 3 列（URL コピー / 納品ページ / 編集）は既存ボタンを維持。
  const rawColumns = [
    ellipsisColumn({
      title: 'タイトル',
      dataIndex: 'main_title',
      key: 'main_title',
      width: 240,
      sorter: textSorter('main_title'),
    }),
    {
      title: '視聴開始',
      dataIndex: 'delivery_s',
      key: 'delivery_s',
      width: 130,
      sorter: dateSorter('delivery_start'),
    },
    {
      title: '視聴終了',
      dataIndex: 'delivery_e',
      key: 'delivery_e',
      width: 130,
      sorter: dateSorter('delivery_end'),
    },
    ellipsisColumn({
      title: '納品説明（管理向け）',
      dataIndex: 'delivery_description',
      key: 'delivery_description',
      width: 300,
      sorter: textSorter('delivery_description'),
    }),
    {
      title: '納品用URL',
      key: 'copy',
      width: 110,
      render: (text, record) => (
        <span>
          <Button size="small" onClick={(e) => copyToClipboard(record, e)}>
            URLコピー
          </Button>
        </span>
      ),
    },
    {
      title: '納品用ページ',
      key: 'open',
      width: 150,
      render: (text, record) => (
        <span>
          <Button size="small" onClick={(e) => openVideoPage(record, e)}>
            納品ページを開く
          </Button>
        </span>
      ),
    },
    {
      title: '編集',
      key: 'edit',
      width: 90,
      render: (text, record) => (
        <span>
          <Button
            size="small"
            onClick={(e) => editVDHandler(record, e)}
            disabled={false}
          >
            編集
          </Button>
        </span>
      ),
    },
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(rawColumns);

  return (
    <PageContainer fluid>
      {/* 検索ツール（画面上部に一列） */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 'var(--space-3)',
          alignItems: 'center',
          marginBottom: 'var(--space-4)',
        }}
      >
        <Input
          placeholder="タイトルで検索"
          allowClear
          value={search.title}
          onChange={(e) => setSearch({ ...search, title: e.target.value })}
          style={{ width: 240 }}
        />
        <Select
          value={search.period}
          onChange={(v) => setSearch({ ...search, period: v })}
          options={[
            { value: 'all', label: '視聴期間：すべて' },
            { value: 'in', label: '視聴期間内' },
            { value: 'out', label: '視聴期間外' },
          ]}
          style={{ width: 200 }}
        />
        <Input
          placeholder="納品説明で検索"
          allowClear
          value={search.desc}
          onChange={(e) => setSearch({ ...search, desc: e.target.value })}
          style={{ width: 240 }}
        />
        <Button onClick={clearSearch}>クリア</Button>
      </div>
      <div ref={wrapRef}>
        <Table
          columns={columns}
          components={components}
          scroll={scroll}
          dataSource={filteredVDInfo}
          size="middle"
          rowKey="_id"
        />
      </div>

      <Button type={'primary'} size="small" onClick={(e) => newVDHandler(e)}>
        動画納品新規作成
      </Button>
    </PageContainer>
  );
};

export default VideoDeliveryMgrPage;
